import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon72: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#404040"
        d="m11.176 5.423-7.382 7.55a2.243 2.243 0 0 0-.006 3.123c.85.868 2.235.865 3.086-.006l10.13-10.36c1.3-1.329 1.337-3.423.053-4.738a3.28 3.28 0 0 0-4.71.01L1.404 12.192c-1.554 1.591-1.876 4.074-.672 5.85 1.59 2.346 4.824 2.62 6.768.63l8.332-8.52a.5.5 0 0 0-.715-.699l-8.331 8.52c-1.505 1.538-3.992 1.328-5.226-.494-.927-1.366-.674-3.326.559-4.588L13.062 1.7a2.281 2.281 0 0 1 3.28-.009c.898.92.873 2.394-.052 3.34L6.159 15.39c-.46.47-1.2.472-1.656.006a1.243 1.243 0 0 1 .006-1.726l7.38-7.549a.5.5 0 1 0-.713-.699Z"
      />
    </Svg>
  )
}
